import script from "./TopArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TopArea.vue?vue&type=script&setup=true&lang=js"

import "./TopArea.vue?vue&type=style&index=0&id=7c46ed85&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c46ed85"]])

export default __exports__